/**
 * Ticket copy formats the threshold as lira, and dates as the audience reads
 * them. The event is TRY-only by construction, so the currency is not a field
 * and cannot disagree with the symbol.
 */
export function formatLira(amount: number): string {
  return `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(amount)} TL`;
}

export function formatDateRange(startIso: string, endIso: string): string {
  const formatter = new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${formatter.format(new Date(startIso))} – ${formatter.format(new Date(endIso))}`;
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('tr-TR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}

/**
 * The event's rule, in the site's voice: "Her 1.000 TL yatırıma 1 bilet."
 *
 * Built from the configured pair rather than stored as prose, so an editor
 * changing the threshold cannot leave the sentence behind.
 */
export function ticketRule(threshold: number, tickets: number): string {
  const per = tickets === 1 ? '1 bilet' : `${tickets} bilet`;

  return `Her ${formatLira(threshold)} yatırıma ${per}`;
}

export function ticketsFor(amount: number, threshold: number, tickets: number): number {
  if (!Number.isFinite(amount) || amount < threshold || threshold <= 0) {
    return 0;
  }

  return Math.floor(amount / threshold) * tickets;
}
